<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column" >   
          <b-field>
            <Multiselect
              placeholder="ເລືອກກຸ່ມສິນຄ້າ"
              v-model.trim="selectedGroup"
              label="NAME"
              track-by="ID"
              :options="groupList"
              @input="getStockProductList"
            >
            </Multiselect>
          </b-field>
        </div>
      </div>
      <b-tabs v-model="activeTab">
        <b-tab-item label="ກຳນົດເລກລຳດັບ">
          <div class="columns">
            <div class="column">
              <h2 class="title">
                ກຳນົດເລກລຳດັບ
              
              </h2>
            </div>
          </div>
        
            
          <div class="columns">
            
            
            <div class="column" style="text-align: right">
              <b-field > 
                <b-button  style="width: 200px;"
                  class="btn-group-margin"
                  type="is-success"  
                  @click="print(1)"
                  >ພິມ
                </b-button>
              </b-field>
            </div>
          </div>                  
          
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
                <th class="has-text-centered " width="2%">#</th>
                <th class="has-text-centered " width="5%">ລດ</th>

                <th class="has-text-left " width="25%">
                  ຊື່ສິນຄ້າ
                </th>
                <th class="has-text-right " width="15%">
                  ຈຳນວນຍັງເຫຼືອ
                </th>
                <!-- <th class="has-text-right " width="15%">
                  ຈຳນວນຕົວຈິງ
                </th>
                <th class="has-text-centered " width="10%">
                  ຈັດການ
                </th>   -->
              </tr>   
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in stockProductList"
                :key="data.ID"
              >
                <td class="has-text-centered ">
                  {{ index + 1 }}
                </td>
                <td class="has-text-centered " style="font-weight: bold;">
                  {{ data.STOCKNUMBER }}
                </td>
                <td class="has-text-left ">
                  {{ data.PRODUCTNAME }}
                </td>
                <td class="has-text-right " >  
                  <span style="color: red;">{{ data.STOCKQUANTITY | formatNumberLocal }}</span> {{data.UNIT}}
                </td>
              

              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        <b-tab-item label="ກວດສິນຄ້າໃນສາງ">
          <div class="columns">
            <div class="column">
              <h2 class="title">
                ກວດສິນຄ້າໃນສາງ
              
              </h2>
            </div>
          </div>
          <div class="columns">
            
            
            <div class="column" style="text-align: right">
              <b-field > 
                <b-button  style="width: 200px;"
                  class="btn-group-margin"
                  type="is-success"  
                  @click="print(2)"
                  >ພິມ
                </b-button>
              </b-field>
            </div>
          </div>                  
          
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
                <th class="has-text-centered " width="2%">#</th>
                <th class="has-text-centered " width="5%">ລດ</th>

                <th class="has-text-left " width="25%">
                  ຊື່ສິນຄ້າ
                </th>
                <th class="has-text-left " width="10%">
                  LOT
                </th>
                <th class="has-text-right " width="15%">
                  ຈຳນວນຍັງເຫຼືອ
                </th>
              </tr>   
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in stockProductListByLot"
                :key="data.ID"
              >
                <td class="has-text-centered ">
                  {{ index + 1 }}
                </td>
                <td class="has-text-centered " style="font-weight: bold;">
                  {{ data.STOCKNUMBER }}
                </td>
                <td class="has-text-left ">
                  {{ data.PRODUCTNAME }}
                </td>
                <td class="has-text-centered " style="font-weight: bold;">
                  {{ data.LOTID }}
                </td>
                <td class="has-text-right " >  
                  <span style="color: red;">{{ data.STOCKQUANTITY | formatNumberLocal }}</span> {{data.UNIT}}
                </td>
              

              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
      </b-tabs>

          
          
       
    </div>

    <div class="contain print-only page-break">
      <div class="contain" v-if="printtype==2">
        <div class="columns">  
          <div class="column">
            <b-field style="font-size: 20px; text-align: center;">ລາຍການຕິດຕາມ-ກວດກາ ສິນຄ້າສາງສິນຄ້າ </b-field>
            <b-field style="font-size: 18px; margin-top: -12px; margin-bottom: -8px; text-align: center;"><span style="font-weight: bold;">{{ selectedGroupName }}</span>  ປະຈຳວັນທີ {{ dateFormatter(currentDate) }}</b-field>
          </div>
        </div>
        <div class="columns">  
          
          <div class="column">
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr style="">
                  <th class="has-text-left set-border" width="5%" style="padding-top: 15px;">
                    ລດ
                  </th>
                  <th class="has-text-centered set-border" width="30%" style="padding-top: 15px;">
                    ຊື່ສິນຄ້າ
                  </th>
                  <th class="has-text-centered set-border" width="10%" style="padding-top: 15px;">
                    LOTID
                  </th>
                  <th class="has-text-centered set-border" width="10%" style="padding-top: 15px;">
                    ຍັງເຫຼືອ
                  </th>
                  <th class="has-text-centered set-border" width="20%" style="padding-top: 15px;">
                    ໝາຍເຫດ
                  </th>
                  
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data) in stockProductListByLot"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border" style="font-weight: bold;">
                    {{ data.STOCKNUMBER }}
                  </td>
                  <td class="has-text-left set-border">
                    {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-left set-border">
                    {{ data.LOTID }}
                  </td>
                  <td class="has-text-right set-border" >  
                    <span style="font-weight: bold;">{{ data.STOCKQUANTITY | formatNumberLocal }}</span> {{data.UNIT}}
                  </td>

                  <td class="has-text-right set-border" >  
                   
                  </td>
                  
                </tr>
              </tbody>
              
            </table>
          </div>
        </div>
      </div>

      <div class="contain"  v-else>
        <div class="columns">  
          <div class="column">
            <b-field style="font-size: 20px; text-align: center;">ລາຍການ ກຳນົດເລກລຳດັບ ສິນຄ້າ </b-field>
            <b-field style="font-size: 18px; margin-top: -12px; margin-bottom: -8px; text-align: center;"><span style="font-weight: bold;">{{ selectedGroupName }}</span>  ປະຈຳວັນທີ {{ dateFormatter(currentDate) }}</b-field>
          </div>
        </div>
        <div class="columns">  
          
          <div class="column">
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr style="">
                  <th class="has-text-left set-border" width="5%" style="padding-top: 15px;">
                    ລດ
                  </th>
                  <th class="has-text-centered set-border" width="30%" style="padding-top: 15px;">
                    ຊື່ສິນຄ້າ
                  </th>   
                  <th class="has-text-centered set-border" width="10%" style="padding-top: 15px;">
                    ຍັງເຫຼືອ
                  </th>
                  <th class="has-text-centered set-border" width="20%" style="padding-top: 15px;">
                    ໝາຍເຫດ
                  </th>
                  
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data) in stockProductList"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border" style="font-weight: bold;">
                    {{ data.STOCKNUMBER }}
                  </td>
                  <td class="has-text-left set-border">
                    {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border" >  
                    <span style="font-weight: bold;">{{ data.STOCKQUANTITY | formatNumberLocal }}</span> {{data.UNIT}}
                  </td>

                  <td class="has-text-right set-border" >  
                   
                  </td>
                  
                </tr>
              </tbody>
              
            </table>
          </div>
        </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,
      activeTab2: 0,
      
      stockProductList: [],
      stockProductListByLot: [],
      requestdate: null,

      stockVenderList: [],
      selectedVender: null,

      purchaserList: [],
      selectedPurchaser: null,

      stockMarketPurchaseList: [],

      selectedRedate: null,
      selectedBatchid: null,

      purchaserDetailList: [],

      selectedpurchaseid: null,

      groupList: [],
      selectedGroup: null,
      selectedGroupName: null,

      isConfirmed: 0,
      marketbatchstatus: 0,
      printtype: null,

      currentDate: null,

    };
    
    
  },
  methods: {   
  
    getStockProductGroup() {
      RestAPI.getClinicStockProductGroup()
        .then((res) => {
          this.groupList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // saveStockProductRequest(){
    //   this.isConfirmed = 0;  
    //   this.$swal({ 
    //       title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
    //       showCancelButton: true,
    //       showCloseButton: true,
    //       confirmButtonText: "ຕ້ອງການ",
    //       cancelButtonText: "ບໍ່ຕ້ອງການ",  
    //       confirmButtonColor: "#d33",
    //       cancelButtonColor: "#3085d6",
    //     }).then((result) => {
    //       if (result.value) {

    //         var params = {
    //           data: this.stockProductList,  
    //           username: this.username,    
    //         };
    //         // console.log("pararms: " + JSON.stringify(params))  
    //         const loadingComponent = this.$loading.open({});
    //         RestAPI.saveStockProductRequestV2(params)
    //           .then((res) => {
    //             if(res.data=="ok"){
    //               this.$swal({
    //                 title: "ສຳເລັດ",
    //                 text: "ດຳເນີນການ ສຳເລັດ!",
    //                 icon: "success",
    //                 timer: 500,
    //                 showConfirmButton: false, 
    //               });
    //             }
                
    //             loadingComponent.close();
    //             this.getStockProductList();
               
    //           })  
    //           .catch((error) => {
    //             loadingComponent.close();
    //             console.log(error);
    //             if (error == "Error: Request failed with status code 400") {
    //               this.$swal("Check Input Data", "", "error");
    //             } else {
    //               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //             } 
    //           });

            

    //       }
    //     });

    // },
    

    getStockProductList() {
      var groupid = this.selectedGroup ? this.selectedGroup.ID : 0;
      this.selectedGroupName =  this.selectedGroup ?  this.selectedGroup.NAME : 'ສິນຄ້າທັງໝົດ';
      RestAPI.getStockProductListForCheck(groupid)
      .then((res) => {
        // console.log("res: "+ JSON.stringify(res.data) )
        this.stockProductList = res.data.list;
        this.stockProductListByLot = res.data.lot;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    print(type) {
      this.printtype = type;
      setTimeout(() => {
            var loadingComponent = this.$loading.open({}); 
            window.print(); 
            loadingComponent.close();

          }, 2000);
      
    },

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();

    this.requestdate = new Date();

    this.getStockProductList();

    this.getStockProductGroup();

  },

  computed: {


   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 35%;
}
.column-60 {
  flex: 0 0 65%;
}

.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}


@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
